import Fuse from 'fuse.js';

const fuseSearch = (items, search, keys, { threshold: customThreshold } = {}) => {
  if (!items || items.length === 0) {
    return [];
  }

  if (!search || !search.trim()) {
    return items;
  }

  const fuse = new Fuse(items, {
    keys,
    threshold: customThreshold ?? 0.5,
    includeScore: true,
    minMatchCharLength: 1,
    ignoreLocation: true,
    findAllMatches: true
  });

  const results = fuse.search(search);
  return results.map((result) => result.item);
};

export default fuseSearch;
